/**
 * Room ID検証ユーティリティ
 * ModerationDashboard.tsx での画像取得前にroomIdの妥当性をチェックする
 */

export interface RoomValidationResult {
  isValid: boolean;
  roomId: string | null;
  error?: string;
}

/**
 * sessionStorageからroomIdを取得し、妥当性を検証する
 * @returns RoomValidationResult 検証結果
 */
export const validateRoomId = (): RoomValidationResult => {
  const roomId = sessionStorage.getItem("roomid");


  // roomIdが存在しない、または空文字列の場合
  if (!roomId || roomId.trim() === "") {
    return {
      isValid: false,
      roomId: null,
      error: "Room IDが設定されていません。ページを再読み込みしてください。"
    };
  }

  const trimmedRoomId = roomId.trim();

  // UUID形式の簡易チェック (xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx)
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  if (!uuidRegex.test(trimmedRoomId)) {
    return {
      isValid: false,
      roomId: null,
      error: "無効なRoom ID形式です。正しいルームに参加していることを確認してください。"
    };
  }

  return {
    isValid: true,
    roomId: trimmedRoomId,
  };
};

/**
 * roomIdをsessionStorageに安全に保存する
 * @param roomId 保存するroomId
 * @returns boolean 保存成功可否
 */
export const setRoomId = (roomId: string): boolean => {
  try {
    if (!roomId || roomId.trim() === "") {
      console.warn("[roomValidation] Empty roomId provided to setRoomId");
      return false;
    }

    const trimmedRoomId = roomId.trim();
    sessionStorage.setItem("roomid", trimmedRoomId);

    // 保存後に検証して確認
    const validation = validateRoomId();
    return validation.isValid;
  } catch (error) {
    console.error("[roomValidation] Failed to set roomId:", error);
    return false;
  }
};

/**
 * roomIdをsessionStorageから安全に削除する
 */
export const clearRoomId = (): void => {
  try {
    sessionStorage.removeItem("roomid");
  } catch (error) {
    console.error("[roomValidation] Failed to clear roomId:", error);
  }
};
